
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/decae7cc1212f168c5dab152d5c92441/815f68b8f034d8bf8d9f20bbe7b78c92.png" 
                alt="Holman Brown Design Logo" 
                className="h-12 w-auto"
              />
              <span className={`ml-3 text-xl font-semibold transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}>
                Holman Brown Design
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('home')}
                className={`text-sm font-medium transition-colors hover:text-amber-700 cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className={`text-sm font-medium transition-colors hover:text-amber-700 cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className={`text-sm font-medium transition-colors hover:text-amber-700 cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className={`text-sm font-medium transition-colors hover:text-amber-700 cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`text-sm font-medium transition-colors hover:text-amber-700 cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-900' : 'text-white'
                }`}
              >
                Contact
              </button>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`md:hidden p-2 rounded-lg transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-3 space-y-3">
              <button
                onClick={() => scrollToSection('home')}
                className="block w-full text-left px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('products')}
                className="block w-full text-left px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap"
              >
                Products
              </button>
              <button
                onClick={() => scrollToSection('gallery')}
                className="block w-full text-left px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap"
              >
                Gallery
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Page Sections */}
      <div id="home">
        <Hero scrollToSection={scrollToSection} />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="products">
        <Products />
      </div>
      <div id="gallery">
        <Gallery />
      </div>
      <div id="contact">
        <Contact />
      </div>

      <Footer />
    </div>
  );
}
